import React, { useState, useEffect, useContext } from "react";
import { StoreContext } from "../../store/StoreProvider";

const useModulePublic = () => {
  const [state] = useContext(StoreContext);
  const { user, common } = state;
  const { moduleSetting } = common;
  const { role: userRole, group } = user;

  // todo: 之後加入其他判斷條件, e.g.費用級距 => 會影響可以建立幾個 group,group 可以有多少成員
  /**
   *
   * @param moduleId {string}
   * @param dependOnGroup {boolean} 是否依賴 groupRole 來判斷
   * @returns {boolean}
   */
  const handlePublic = (moduleId, dependOnGroup = true) => {
    if (!(userRole && moduleId && moduleSetting)) return false;
    if (!(moduleId in moduleSetting)) return false;
    const singleMs = moduleSetting[moduleId];
    // roles: "admin,developer" or "admin,developer,editor"
    const { isPublic, roles } = singleMs;
    if (!isPublic) return false;
    const moduleSettingRolesList = roles
      .split(",")
      .filter((r) => !!r)
      .map((r) => r.trim());
    const groupRolesList = (group.role || "")
      .split(",")
      .filter((r) => !!r)
      .map((r) => r.trim());
    const userRoleList = userRole
      .split(",")
      .filter((r) => !!r)
      .map((r) => r.trim());

    if (!dependOnGroup) {
      return (
        userRoleList.filter((ele) => moduleSettingRolesList.includes(ele))
          .length > 0
      );
    }

    return (
      userRoleList.filter((ele) => moduleSettingRolesList.includes(ele))
        .length > 0 ||
      groupRolesList.filter((ele) => moduleSettingRolesList.includes(ele))
        .length > 0
    );
  };

  return { handlePublic };
};

export default useModulePublic;
